/**
 * Returns a URLSearchParams object with selected params if they were present in a search string provided. Null otherwise.
 */
export const preserveSearchParams = (
  paramNames: string[],
  search: string = window.location.search
): URLSearchParams | null => {
  if (paramNames.length === 0) {
    return null;
  }

  const searchParams = new URLSearchParams(search);
  let newSearchParams = null;

  for (const paramName of paramNames) {
    const value = searchParams.get(paramName);
    if (value) {
      newSearchParams ??= new URLSearchParams();
      newSearchParams.set(paramName, value);
    }
  }

  return newSearchParams;
};
